module.exports = __webpack_public_path__ + "img/calendario_servicio.c5cff4e6.png";